<template lang="pug">
    section.ai-face-swap-use.section
        ._wrap.wrap
            h2._title {{ content.title }}
            ._description {{ content.description }}
            ._list
                ._item(v-for="(item, index) in list" :key="index")
                    img(:src="require(`../../../assets/images/ai-face-swap-use/${index+1}.png`)")._item-image
                    ._item-title {{ item.title }}
                    ._item-description(v-html="item.description")
</template>

<script>
import aiStatic from "@/seo/ai-static.json";

export default {
    name: "AiFaceSwapUse",
    data() {
        // Текст лежит в ai-static.json: тот же файл использует выгрузка HTML для поисковых ботов
        return {
            content: aiStatic.faceSwapUse,
            list: aiStatic.faceSwapUse.list,
        };
    },
};
</script>

<style lang="scss" src="./ai-face-swap-use.scss"></style>
